import { Box, Alert, Button } from '@mui/material'
import { Refresh as RefreshIcon } from '@mui/icons-material'

interface ErrorStateProps {
  message: string
  onRetry?: () => void
}

const ErrorState = ({ message, onRetry }: ErrorStateProps) => {
  return (
    <Box sx={{ p: 2 }}>
      <Alert
        severity="error"
        sx={{
          borderRadius: 2,
          '& .MuiAlert-message': {
            fontSize: '0.875rem'
          }
        }}
        action={
          onRetry && (
            <Button
              color="inherit"
              size="small"
              onClick={onRetry}
              startIcon={<RefreshIcon fontSize="small" />}
              sx={{ fontWeight: 600 }}
            >
              Retry
            </Button>
          )
        }
      >
        {message}
      </Alert>
    </Box>
  )
}

export default ErrorState
